import chunk from 'lodash.chunk'
import * as moment from 'moment-mini'
import { ruleCodeMapping } from '@/utils/newRuleCodeMapping-Sean'

export const hmList = [
  { label: '号码1', key: 'num1' },
  { label: '号码2', key: 'num2' },
  { label: '号码3', key: 'num3' },
  { label: '号码4', key: 'num4' },
  { label: '号码5', key: 'num5' },
  { label: '号码6', key: 'num6' },
  { label: '号码7', key: 'num7' },
  { label: '号码8', key: 'num8' },
  { label: '号码9', key: 'num9' },
  { label: '号码10', key: 'num10' }
]

export const linkElement = function(options = {}) {
  options.rootKey = options.rootKey ? options.rootKey : '[draw-root]' // 畫布座標的原點
  options.elementKey = options.elementKey ? options.elementKey : '[draw-me="true"]' // 要被連起來的點的共通點
  options.canvasId = options.canvasId ? options.canvasId : 'default-link_element-canvas-id' // 用來區分獨立畫布的時候使用
  options.setting = options.setting ? options.setting : {}
  options.canvasStyle = options.canvasStyle ? options.canvasStyle : {}
  options.eraserSize = options.eraserSize ? options.eraserSize : 15
  options.maxHeight = options.maxHeight ? options.maxHeight : 1000

  const eraserSize = options.eraserSize

  // 覆寫制的設定們
  // const defaultSetting = {}
  const defaultCanvasStyle = {
    strokeStyle: '#000',
    lineWidth: 2,
    lineCap: 'round',
    lineJoin: 'round'
  }
  const runningCanvasStyle = Object.assign(defaultCanvasStyle, options.canvasStyle)

  // 幫座標元素定位對應的值
  const root = document.querySelector(options.rootKey)
  if (!root) {
    console.error('linkElement: rootKey 在畫面上找不到相符的element', options.rootKey)
    return false
  }
  const canvas_width = root.offsetWidth
  const canvas_height = root.offsetHeight

  let points = document.querySelectorAll(options.elementKey)
  if (points.length === 0) {
    console.error('linkElement: elementKey 在畫面上沒有找到任何相符的element', options.elementKey)
    return false
  }

  // 繪圖邏輯開始
  points = [].map.call(points, (item) => {
    const axis = _getAxis(item, root)
    const width = item.offsetWidth
    const height = item.offsetHeight
    const x = axis.x
    const y = axis.y
    const cx = x + width / 2
    const cy = y + height / 2
    return {
      element: item,
      x,
      y,
      cx,
      cy,
      width,
      height
    }
  })

  // 由於canvas 有尺寸限制、所以用有疊合的canvas 們 做出整個大張的圖
  const canvasInfoArray = [{ top: 0, left: 0, height: 0, width: canvas_width, points: [] }]
  let accumMaxHeightTimes = 1
  let accumMaxHeight = accumMaxHeightTimes * options.maxHeight
  let currentCanvasArrayIndex = 0
  points.forEach((point, index) => {
    if (point.y >= accumMaxHeight) {
      canvasInfoArray[currentCanvasArrayIndex].height = point.y - canvasInfoArray[currentCanvasArrayIndex].top

      accumMaxHeightTimes++
      currentCanvasArrayIndex++
      accumMaxHeight = options.maxHeight * accumMaxHeightTimes

      const previousPoint = points[index - 1]

      canvasInfoArray[currentCanvasArrayIndex] = { top: previousPoint.y, left: 0, height: 0, width: canvas_width, points: [{ ...previousPoint }] }
    }
    canvasInfoArray[currentCanvasArrayIndex].points.push({ ...point })
  })
  canvasInfoArray[currentCanvasArrayIndex].height = canvas_height - canvasInfoArray[currentCanvasArrayIndex].top // 幫最後一個canvasDOM 加上高度

  window.canvasInfoArray = canvasInfoArray

  // canvas前置整理
  canvasInfoArray.forEach((canvasItem, canvasIndex) => {
    // 計算canvas 尺寸
    canvasItem.minX = canvasItem.points.slice().sort((a, b) => a.cx - b.cx)[0].cx
    canvasItem.maxX = canvasItem.points.slice().sort((a, b) => b.cx - a.cx)[0].cx

    canvasItem.left = canvasItem.minX
    canvasItem.width = canvasItem.maxX - canvasItem.minX

    const selectKey = `canvas[link_element-canvas-id="${options.canvasId}"][link_element-canvas-sequence="${canvasIndex}"]`
    const previousDOM = document.querySelector(selectKey)
    const canvasDOM = previousDOM !== null ? previousDOM : document.createElement('canvas')
    canvasDOM.width = canvasItem.width
    canvasDOM.height = canvasItem.height

    canvasDOM.style.position = 'absolute'
    canvasDOM.style.top = `${canvasItem.top}px`
    canvasDOM.style.left = `${canvasItem.left}px`

    canvasDOM.setAttribute('link_element-canvas-id', options.canvasId)
    canvasDOM.setAttribute('link_element-canvas-sequence', canvasIndex)

    root.appendChild(canvasDOM)

    _draw_canvas_line(canvasDOM, canvasItem, runningCanvasStyle)
  })
  // 開始畫canvas
  function _draw_canvas_line(canvas, canvasInfo, runningCanvasStyle) {
    const c = canvas.getContext('2d')
    Object.assign(c, runningCanvasStyle)

    const { points } = canvasInfo

    // 整理偏移值
    points.forEach((point) => {
      point.cx = point.cx - canvasInfo.left
      point.cy = point.cy - canvasInfo.top
    })

    c.beginPath()
    c.moveTo(points[0].cx, points[0].cy)
    for (let i = 1; i < points.length; i++) {
      const point = points[i]
      c.lineTo(point.cx, point.cy)
    }
    c.stroke()
    c.closePath()

    // 疊合消去:
    // 這裡視情況看要不要做save 和restore 的補正
    c.globalCompositeOperation = 'destination-out'
    c.fillStyle = 'black' // 實心顏色即可
    for (let i = 0; i < points.length; i++) {
      c.beginPath()
      const point = points[i]
      c.arc(point.cx, point.cy, eraserSize, 0, 2 * Math.PI, false)
      c.fill()
    }
    c.closePath()
  }

  function _getAxis(element, root) {
    // 修改
    // https://stackoverflow.com/questions/1480133/how-can-i-get-an-objects-absolute-position-on-the-page-in-javascript
    var x = 0
    var y = 0

    do {
      x += element.offsetLeft
      y += element.offsetTop
      element = element.offsetParent
    } while (element !== root && element)

    return {
      x: x,
      y: y
    }
  }
}

export const haoMaGuiLu_method = {
  drawTrendCanvas(color = '#0899EC', lineWidth = 2) {
    this.$nextTick(() => {
      linkElement({
        canvasStyle: {
          strokeStyle: color,
          lineWidth
        }
      })
    })
  },
  removeTrendCanvas(selector = '[link_element-canvas-id]') {
    const canvasDOM = document.querySelector(selector)
    if (!canvasDOM) return
    canvasDOM.parentNode.removeChild(canvasDOM)
  },
  setTable() {
    this.getChunkData()
    this.getTableList()
  },
  formatStatsData() {
    function _makeUpForTableList(data) {
      const defaultKeys = [
        'id',
        'period',
        'drawTime',
        'drawDate',
        'balls',
        'hmDaXiao',
        'hmDanShuang',
        'hmGueiLyu',
        'hmGueiLyuShengPingJiang'
      ]
      const formatData = JSON.parse(JSON.stringify(data))
      defaultKeys.forEach((key) => {
        switch (key) {
          case 'id':
          case 'period':
          case 'drawTime':
          case 'drawDate':
            if (!formatData[key]) formatData[key] = ''
            break
          case 'balls':
          case 'hmDaXiao':
          case 'hmDanShuang':
          case 'hmGueiLyu':
          case 'hmGueiLyuShengPingJiang':
            if (!formatData[key]) formatData[key] = []
            break
        }
      })
      return formatData
    }
    return this.hmGuiLuStatsList['cpRuleDetails'].map((data) => {
      const returnObject = {}
      // 補齊資料 (防 API 遺漏)
      const defaultData = _makeUpForTableList(data)
      const period = defaultData.period
      const drawTime = moment(defaultData.drawTime).format('MM-DD HH:mm')
      const balls = {}
      for (let currentHm = 1; currentHm <= defaultData.balls.length; currentHm++) {
        const arrayKey = currentHm - 1
        balls[`num${currentHm}`] = defaultData.balls.map((ball) => {
          const gueiLu = defaultData.hmGueiLyu[arrayKey]
          const beDrawn = ball === gueiLu
          const beChosen = currentHm === ball && !beDrawn ? 'hightlight' : ''
          let beLinked
          if (beDrawn) beLinked = ball === 10 ? `ball-${ball}` : `ball-0${ball}`
          return { ball, beDrawn, beChosen, beLinked }
        })
      }
      const hmGueiLyuShengPingJiang = defaultData.hmGueiLyuShengPingJiang.reduce((acc, val, idx) =>
        Object.assign(acc, { [`num${idx + 1}`]: ruleCodeMapping[val] }), {})
      const hmDanShuang_dan = defaultData.hmDanShuang.reduce((acc, val, idx) =>
        Object.assign(acc, { [`num${idx + 1}`]: val === 'danshuang_dan' ? '单' : '' }), {})
      const hmDanShuang_shuang = defaultData.hmDanShuang.reduce((acc, val, idx) =>
        Object.assign(acc, { [`num${idx + 1}`]: val === 'danshuang_shuang' ? '双' : '' }), {})
      const hmDaXiao_da = defaultData.hmDaXiao.reduce((acc, val, idx) =>
        Object.assign(acc, { [`num${idx + 1}`]: val === 'daxiao_da' ? '大' : '' }), {})
      const hmDaXiao_xiao = defaultData.hmDaXiao.reduce((acc, val, idx) =>
        Object.assign(acc, { [`num${idx + 1}`]: val === 'daxiao_xiao' ? '小' : '' }), {})
      Object.assign(returnObject, {
        period,
        drawTime,
        balls,
        hmGueiLyuShengPingJiang,
        hmDanShuang_dan,
        hmDanShuang_shuang,
        hmDaXiao_da,
        hmDaXiao_xiao
      })
      return returnObject
    })
  },
  getChunkData() {
    this.chunkData = {
      _observer: null,
      list: chunk(this.formatStatsData(), 30),
      index: 0
    }
  },
  getTableList() {
    this.tableList = this.chunkData.list[this.chunkData.index]
  },
  activeLazyLoading() {
    if (this.chunkData._observer) return
    const bottomDom = document.querySelector('.scrollBottom')
    if (!bottomDom) return

    this.chunkData._observer = new IntersectionObserver(_onEnterView)
    this.chunkData._observer.observe(bottomDom)
    const vm = this
    function _onEnterView(entries, observer) {
      for (const entry of entries) {
        if (!entry.isIntersecting) return
        vm.chunkData.index++
        if (!vm.chunkData.list[vm.chunkData.index]) {
          observer.unobserve(entry.target)
          return
        }
        vm.tableList = vm.tableList.concat(vm.chunkData.list[vm.chunkData.index])
        vm.drawTrendCanvas()
      }
    }
  },
  setChart() {
    const allCounts = this.hmGuiLuStatsList['numberCounts'][this.currentHm].map((ele) => ele.count)
    const maxVal = Math.max(...allCounts)
    let interval
    if (maxVal >= 100) interval = 20
    else if (maxVal >= 50) interval = 10
    else if (maxVal >= 10) interval = 5
    else interval = 1
    this.chartOptions.yAxis[0].max = maxVal + interval
    this.chartOptions.yAxis[0].interval = interval
    this.chartOptions.series[0].data = [...allCounts]
  },
  setTextColor(text) {
    switch (text) {
      case '升':
      case '双':
      case '大':
        return 'red'
      case '降':
        return 'blue'
    }
  },
  setCurrentHm(ballObj) {
    if (this.activeHm) return ballObj.beChosen
    else return ''
  },
  activeSameDigit() {
    this.activeHm = !this.activeHm
  }
}
